import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../shared/inputs/TextInput';
import Button from '../../../shared/buttons/Button';
import Select from '../../../shared/inputs/Select';
import ErrorMessage from '../../../shared/message/ErrorMessage';

const TeamWebhooksForm = ({ onSave, onClose, onFormChange, form, types }) => {
  const renderer = (option) => <span>{option.name}</span>;
  const value = types.find((element) => {
    return element.id === form.type;
  });

  return (
    <div>
      <h2>New webhook</h2>
      {form.error && <ErrorMessage error={form.error} dismissable={true} />}
      <TextInput label="Title" name="title" onChange={onFormChange} value={form.title} />
      <TextInput label="URL" name="url" onChange={onFormChange} value={form.url} />
      <div className="form-group">
        <label>Trigger</label>
        <Select
          value={value}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          className="enum-dropdown"
          options={types}
          onChange={onFormChange}
          clearable={false}
          searchable={false}
          valueRenderer={renderer}
          optionRenderer={renderer}
        />
      </div>
      <Button extraClass="bulk-action-btn" buttonText="Save" onClick={onSave} />{' '}
      <Button onClick={onClose} extraClass="bulk-action-btn grey" buttonText="Close" />
    </div>
  );
};

TeamWebhooksForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  types: PropTypes.array.isRequired,
};

export default TeamWebhooksForm;
